import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import PopupModal from '../../../Manage/PopupModal';
import ManageTable from '../../../Manage/ManageTable';

const InteractionHistory = () => {
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);

    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    // New mock data
    const mockData = [
        {
            product_id: "#123456789",
            date_of_interaction: "30/04/2024",
            type: "Like",
            action: "View"
        },
        {
            product_id: "#123456789",
            date_of_interaction: "30/04/2024",
            type: "Viewed",
            action: "View"
        },
        {
            product_id: "#123456789",
            date_of_interaction: "30/04/2024",
            type: "Shared",
            action: "View"
        }
    ];

    useEffect(() => {
        // Simulate fetching data
        setTableData(mockData);
        setLoading(false);
    }, []);

    const columns = [
        {
            name: "Product ID",
            cell: (row) => <span title={row.product_id} className="ellipsis">{row.product_id}</span>,
            selector: (row) => row.product_id,
            sortable: true,
        },
        {
            name: "Date of Interaction",
            cell: (row) => <span title={row.date_of_interaction} className="ellipsis">{row.date_of_interaction}</span>,
            selector: (row) => row.date_of_interaction,
            sortable: true,
        },
        {
            name: "Type",
            cell: (row) => <span title={row.type} className="ellipsis">{row.type}</span>,
            selector: (row) => row.type,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => <span title={row.action} className="ellipsis">{row.action}</span>,
            selector: (row) => row.action,
            sortable: true,
        },
    ];

    return (
        <>
            <div>
                {loading ? <Loader /> :
                    <ManageTable
                        name={'Interaction History'}
                        columns={columns}
                        setTableData={setTableData}
                        tableData={tableData}
                    />
                }
            </div>

            <PopupModal
                company_id={''}
                open={modal}
                setModal={setModal}
                handleModal={handleModal}
                name={''}
                tableData={''}
                setTableData={''}
            />
        </>
    );
}

export default InteractionHistory;
